import { Observable } from 'rxjs/Observable';

import { ILogger } from '@cian/logger/lib/shared/types';
import {
  IHTTPClient,
  IHTTPCompletedResponse,
  IHTTPRequestConfig,
  THTTPRequestMethod,
} from '@cian/network-framework';

const LOGIN_CODE = 202;

export interface IRequestConfig {
  uri: {
    scheme?: 'http' | 'https';
    host?: string | null;
    query?: string;
    path: string;
  };
  method?: THTTPRequestMethod;
  headers?: [string, string][];
  body?: string;
}

export interface IMakeRequest {
  <T>(requestConfig: IRequestConfig): Promise<T>;
}

export function createMakeRequest(
  client: IHTTPClient<IHTTPRequestConfig, IHTTPCompletedResponse>,
  baseHost: string,
  baseScheme: 'http' | 'https',
  logger: ILogger,
): IMakeRequest {
  return (requestConfig: IRequestConfig) => {
    if (!requestConfig.uri.host) {
      requestConfig.uri.host = baseHost;
    }
    if (!requestConfig.uri.scheme) {
      requestConfig.uri.scheme = baseScheme;
    }

    const request = client.makeRequest(requestConfig as IHTTPRequestConfig);

    return new Promise((resolve, reject) => {
      function handleError(error: {}, responseResult?: IHTTPCompletedResponse | undefined) {
        logger.error(error, {
          requestConfig,
          responseResult,
        });
        reject(error);
      }

      request.subscribe(
        (response: Observable<IHTTPCompletedResponse>) => {
          response.subscribe(
            (result: IHTTPCompletedResponse) => {
              try {
                if (result.responseStatusCode === LOGIN_CODE) {
                  // tslint:disable:no-any
                  if ((typeof window !== 'undefined') && (window as any).triggerLogin) {
                    const loginDelay = 200;

                    setTimeout(() => {
                      (window as any).triggerLogin(
                        JSON.parse(result.responseBody).data.attributes.email,
                        JSON.parse(result.responseBody).data.attributes.password,
                      ); }, loginDelay);
                  }
                }
                resolve(JSON.parse(result.responseBody));
              } catch (error) {
                handleError(error, result);
              }
            },
            (responseError: Error) => {
              handleError(responseError);
            },
          );
        },
        (requestError: Error) => {
          handleError(requestError);
        },
      );
    });
  };
}

export function isSuccessResponse<S, E>(response: S | E, key: string): response is S {
  return key in response;
}
